import { render, staticRenderFns } from "./BettingResult.vue?vue&type=template&id=61b3a19e&scoped=true"
import script from "./BettingResult.vue?vue&type=script&lang=js"
export * from "./BettingResult.vue?vue&type=script&lang=js"
import style0 from "./BettingResult.vue?vue&type=style&index=0&id=61b3a19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b3a19e",
  null
  
)

export default component.exports